import { render, staticRenderFns } from "./CaseModule.vue?vue&type=template&id=41716808&scoped=true"
import script from "./CaseModule.vue?vue&type=script&lang=js"
export * from "./CaseModule.vue?vue&type=script&lang=js"
import style0 from "./CaseModule.vue?vue&type=style&index=0&id=41716808&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41716808",
  null
  
)

export default component.exports